import { render, staticRenderFns } from "./AboutSections.vue?vue&type=template&id=47f7592f&"
import script from "./AboutSections.vue?vue&type=script&lang=js&"
export * from "./AboutSections.vue?vue&type=script&lang=js&"
import style0 from "./AboutSections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports